import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import {
  XlsxExportOptions,
  DA_XLSX_CONFIG,
  XlsxConfig,
  XlsxExportSheet
} from './interface';
import {LazyResult, LazyService} from '../core/lazy.service';

declare var XLSX: any;
// import * as XLSX from 'xlsx';
function fixdata(data) {
  // æä»¶æµè½¬BinaryString
  var o = '',
    l = 0,
    w = 10240;
  for (; l < data.byteLength / w; ++l)
    o += String.fromCharCode.apply(
      null,
      new Uint8Array(data.slice(l * w, l * w + w))
    );
  o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
  return o;
}

@Injectable()
export class XlsxService {
  constructor(
    @Inject(DA_XLSX_CONFIG) private config: XlsxConfig,
    private http: HttpClient,
    private lazy: LazyService
  ) {}

  private init(): Promise<LazyResult[]> {
    const config = Object.assign(
      {
        url: `//cdn.bootcss.com/xlsx/0.12.12/xlsx.full.min.js`,
        modules: []
      },
      this.config
    );

    return this.lazy.load([config.url].concat(config.modules));
  }

  private read(wb: any): { [key: string]: any[][] } {
    const ret: any = {};
    wb.SheetNames.forEach(name => {
      const sheet: any = wb.Sheets[name];
      ret[name] = XLSX.utils.sheet_to_json(sheet, { header: 1 });
    });
    return ret;
  }

  /**
   * å¯¼å¥Excelå¹¶è¾åºJSONï¼æ¯æ `<input type="file">`ãURL å½¢å¼
   * @param rABS å è½½æ°æ®æ¹å¼ `readAsBinaryString` ï¼é»è®¤ï¼ æ `readAsArrayBuffer`ï¼[æ´å¤ç»è](http://t.cn/R3n63A0)
   */
  import(
    fileOrUrl: File | string,
    rABS: 'readAsBinaryString' | 'readAsArrayBuffer' = 'readAsBinaryString'
  ): Promise<{ [key: string]: any[][] }> {
    return new Promise<{ [key: string]: any[][] }>((resolver, reject) => {
      this.init().then(() => {
        // from url
        if (typeof fileOrUrl === 'string') {
          this.http
            .request('GET', fileOrUrl, { responseType: 'arraybuffer' })
            .subscribe(
              (res: ArrayBuffer) => {
                const wb = XLSX.read(new Uint8Array(res), {
                  type: 'array',
                  cellText: false,
                  raw: true
                });
                resolver(this.read(wb));
              },
              (err: any) => {
                reject(err);
              }
            );
          return;
        }
        // from file
        const reader: FileReader = new FileReader();
        // var rABS = false; // æ¯å¦å°æä»¶è¯»åä¸ºäºè¿å¶å­ç¬¦ä¸²
        reader.onload = (e: any) => {
          if (rABS === 'readAsArrayBuffer') {
            const wb: any = XLSX.read(btoa(fixdata(e.target.result)), {
              // æå¨è½¬å
              type: 'base64',
              raw: true
            });
            resolver(this.read(wb));
          } else {
            const wb: any = XLSX.read(e.target.result, {
              type: 'binary',
              raw: true
            });
            resolver(this.read(wb));
          }
        };
        reader[rABS](fileOrUrl);
      });
    });
  }

  /** å¯¼åº */
  export(options: XlsxExportOptions): Promise<void> {
    return this.init().then(() => {
      const wb: any = XLSX.utils.book_new();
      if (Array.isArray(options.sheets)) {
        (<XlsxExportSheet[]>options.sheets).forEach(
          (value: XlsxExportSheet, index: number) => {
            const ws: any = XLSX.utils.aoa_to_sheet(value.data);
            XLSX.utils.book_append_sheet(
              wb,
              ws,
              value.name || `Sheet${index + 1}`
            );
          }
        );
      } else {
        wb.SheetNames = Object.keys(options.sheets);
        wb.Sheets = options.sheets;
      }

      if (options.callback) options.callback(wb);

      const wbout: ArrayBuffer = XLSX.write(
        wb,
        Object.assign(
          {
            bookType: 'xlsx',
            bookSST: false,
            type: 'array'
          },
          options.opts
        )
      );
      saveAs(
        new Blob([wbout], { type: 'application/octet-stream' }),
        options.filename || 'export.xlsx'
      );
    });
  }
}
